module.exports = __webpack_public_path__ + "img/playing.5c75815c.gif";